<template>
    <spinner v-if="isLoading" />
    <transition name="fade">
        <div>
            <BreadCrumbs :breadCrumbs="breadCrumbs" :title="title" :back_title="backTitle" :link="link" />

            <div class="page">
                <!-- v-if / v-else -->
                <div v-if="items.length">
                    <router-link v-for="item in items" :key="item.id"
                        :to="{ name: 'SliderDetail', params: { sliderId: item.id } }"
                        class="d-block text-decoration-none text-body">
                        <div class="mt-3 fw-normal">
                            <div class="hstack d-flex justify-content-between item_title pb-2 mb-2">
                                <div class="fs-4 fw-bold">{{ item.name }}</div>
                            </div>
                        </div>
                    </router-link>
                </div>
                <div v-else>
                    <div class="mb-3">
                        <div class="item_title fw-semibold">
                            Слайдеров нет!
                        </div>
                    </div>
                </div>

                <!-- модалка остаётся как была -->
                <transition name="slide-fade">
                    <Modal v-if="isModalVisible" @close="closeModal">
                        <template v-slot:body>
                            <!-- … ваш код формы … -->
                        </template>
                    </Modal>
                </transition>
            </div>
        </div>
    </transition>

    <transition name="slide-fade">
        <toast-alert v-if="isAlert" @close_alert="isAlert = false" :message="alertMessage" :type="alertType" />
    </transition>
</template>

<script>
import * as req from "../../../services/boards";
import Spinner from "../../../components/Spinner.vue";
import BreadCrumbs from "../../../Page/BreadCrumbs.vue";
import Button from "../../../components/Button.vue";
import Modal from "../../../components/Modal.vue";
import ToastAlert from "../../../components/ToastAlert.vue";

export default {
  name: "Sliders",
  components: { Spinner, BreadCrumbs, Button, Modal, ToastAlert },
  data() {
    return {
      items: [],
      isLoading: false,
      isModalVisible: false,
      form: { id: null, name: "", enabled: true },
      errors: { name: "" },
      formTitle: "",
      isEdit: false,
      isAlert: false,
      alertMessage: "",
      alertType: "green",
      breadCrumbs: true,
      title: "Слайдеры",
      backTitle: "Доска TO",
      link: "boards/doska-to",
      boardId: 2,
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      this.isLoading = true;
      try {
        this.items = await req.getSliders(this.boardId);
      } catch (e) {
        console.error(e);
      } finally {
        this.isLoading = false;
      }
    },
    // … остальные методы без изменений …
  },
};
</script>

<style scoped>
.av_card {
  border: 1px solid #ddd;
  padding: 1rem;
  margin-bottom: 1rem;
}
</style>
